import React from 'react'
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import './Banner.css'
import NavLink from '../../../../Helpers/NavLink/NavLink';
const SecondHeader = (props) => {

    const home_bread = {
        id: '1',
        label: 'Home',
        path: '/'
    }
    const breadCrum_Data = props.breadcrumb;
    const array = [home_bread, breadCrum_Data]
    return (
        <div className="banner">
            <img src="/Img/SecondHeader.png" alt="Second Header" className="img-responsive" />
            <div className="banner-content-Header">
                <h6>{props.Title}</h6>
                <Breadcrumbs aria-label="breadcrumb" className="banner-content-Header-Bread">
                    {
                        array && array.map((val) => (
                            <NavLink to={val.path} key={val.id} >{val.label}</NavLink>
                        ))
                    }
                </Breadcrumbs>

            </div>
        </div>
    )
}

export default SecondHeader
